import { ReactComponent as Logo } from '../../../assets/logo.svg';

export const Header = ( { title, children } ) => {
	return (
		<div className="masthead">
			<div className="tropical-content">
				<div className="masthead__branding">
					<Logo width="30" height="30" />
					<h1>{ title }</h1>
					{ children }
				</div>
			</div>
		</div>
	);
};
